var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.multi)?_c('span',{class:("icon-" + _vm.name)},_vm._l((10),function(i){return _c('span',{key:i,class:("path" + i)})}),0):_c('span',{class:("icon icon-" + _vm.name)})}
var staticRenderFns = []

export { render, staticRenderFns }